import {
  Box,
  Button,
  Grid,
} from "@mui/material";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import api from 'api/axios';
import Listtable from 'components/common/ListTable';
import ModalScreen from 'components/common/Modal';
import { useOutletContext } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import { IconButton } from "@mui/material";
import ComplaintMaster from "components/ManageComplaints/ComplaintMaster";
import TestMasterSheetActions from "./TestMasterSheetActions";

const DrugList = () => {
  const [count, setCount] = useState(0);
  const [activeTab, setActiveTab] = useState("drug");

  const [pageNumber, setPageNumber] = useState(0);
  const [drugsData, setDrugsData] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [, setBackDropOpen] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [data, setData] = useState({});
  const [list, setList] = useState([]);
  const { searchText } = useOutletContext();
  const tableHeader = [
    "Company Name",
    "Drug Name",
    "Registry ID",
    "Generic Name",
    "Drug Type",
    "Doctor Speciality",
    "Action",
  ];
  const tableHeader2 = ["Name", "Investigation Type", "Action"];
  const tableHeader3 = ["Name", "Code", "Status", "Action"];
  const keysName = [
    "company",
    "drugName",
    "registryIdLabel",
    "genericName",
    "drugType",
    "speciality",
    "action",
  ];

  const keysName2 = ["name", "investigationTypeName", "action"];
  const keysName3 = ["name", "code", "statusLabel", "action"];

  const btnStyle = {
    width: "max-content",
    padding: "0.5rem 2rem",
    color: "#194AF5",
    bgcolor: "#E6EBFF",
    boxShadow: "none",
    borderRadius: "8px",
    ":hover": {
      bgcolor: "#E6EBFF",
      color: "#194AF5",
      boxShadow: "none",
    },
  };
  useEffect(() => {
    const data = list?.filter((x) =>
      activeTab === "drug"
        ? x?.drugName?.toLowerCase()?.includes(searchText.toLowerCase())
        : x?.name?.toLowerCase()?.includes(searchText.toLowerCase())
    );
    setDrugsData(data);
  }, [searchText, list, activeTab]);

  const DrugListData = (e) => {
    if (activeTab === "complaint") return;

    try {
      setBackDropOpen(true);
      const searchValue = e?.target?.value;
      const params = {
        limit: rowsPerPage,
        perPage: rowsPerPage,
        page: pageNumber + 1,
        ...(searchValue && { text: searchValue, search: searchValue }),
      };
      const url =
        activeTab === "investigationType" ? "/investigation-type" : `/${activeTab}`;

      api
        .get(url, { params })
        .then((response) => {
          const responseData = response?.data || {};
          const dataSection = responseData?.data;
          const meta =
            responseData?.meta ||
            dataSection?.meta ||
            responseData?.pagination ||
            dataSection?.pagination ||
            {};

          const candidates =
            activeTab === "drug"
              ? [dataSection?.data, dataSection]
              : [dataSection?.data, dataSection];

          const listData = candidates.find((item) => Array.isArray(item)) || [];

          const normalizedListWithActions = listData.map((item) => ({
            ...item,
            registryIdLabel: item?.registryId || "-",
            investigationTypeName: item?.investigationType?.name || "Pathology",
            statusLabel: item?.isActive === false ? "Inactive" : "Active",
            action: (
              <IconButton onClick={() => handleModal(item)}>
                <EditIcon fontSize="small" color="primary" />
              </IconButton>
            )
          }));

          const normalizedList =
            activeTab === "drug"
              ? [...normalizedListWithActions].reverse()
              : normalizedListWithActions;

          setDrugsData(normalizedList);
          setList(normalizedList);
          const totalCount =
            meta?.total ||
            meta?.totalCount ||
            dataSection?.totalCount ||
            dataSection?.count ||
            responseData?.count ||
            normalizedList.length;
          const parsedTotal = Number(totalCount);
          setCount(
            Number.isFinite(parsedTotal) ? parsedTotal : normalizedList.length
          );

          const metaPerPage = Number(meta?.perPage || meta?.limit);
          if (metaPerPage && metaPerPage !== rowsPerPage) {
            setRowsPerPage(metaPerPage);
          }
          const metaPage = Number(meta?.page);
          if (metaPage && metaPage - 1 !== pageNumber) {
            setPageNumber(metaPage - 1);
          }
          setBackDropOpen(false);
        })
        .catch((err) => {
          setBackDropOpen(false);
          if (err?.response?.data?.message) {
            toast.error(`Error :${err?.response?.data?.message}`);
          } else {
            toast.error("Drugs not found.");
          }
        });
    } catch (error) {
      setBackDropOpen(false);
      toast.error("Drugs list error");
    }
  };

  const handleChangePage = (event, newPage) => {
    setPageNumber(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(Number(event.target.value));
    setPageNumber(0);
  };

  const handleModal = (e) => {
    setData(e);
    setOpenModal(true);
  };
  const handleModalClose = (buttonText = "save") => {
    setData({});
    if (buttonText !== "close") {
      DrugListData();
    }
    setOpenModal(false);
  };

  useEffect(() => {
    DrugListData();
  }, [rowsPerPage, pageNumber, activeTab]);
  return (
    <>
      <Grid container alignItems="center">
        <Grid item sm={12} md={12} lg={12} padding={2}>
          <Grid
            container
            spacing={1}
            sx={{
              padding: "1rem 0",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                mr: "auto",
              }}
            >
              <Box
                onClick={(e) => {
                  setActiveTab("drug");
                }}
                sx={{
                  borderBottom:
                    activeTab === "drug"
                      ? "2px solid #194AF5"
                      : "2px solid transparent",
                  color: activeTab === "drug" ? "#194AF5" : "#7D8DC4",
                  width: "max-content",
                  padding: "0.5rem 1rem",
                  fontWeight: "600",
                  cursor: "pointer",
                }}
              >
                Drugs
              </Box>
              <Box
                onClick={(e) => {
                  setActiveTab("test");
                }}
                sx={{
                  borderBottom:
                    activeTab === "test"
                      ? "2px solid #194AF5"
                      : "2px solid transparent",
                  color: activeTab === "test" ? "#194AF5" : "#7D8DC4",
                  width: "max-content",
                  padding: "0.5rem 1rem",
                  fontWeight: "600",
                  cursor: "pointer",
                }}
              >
                Test
              </Box>
              <Box
                onClick={(e) => {
                  setActiveTab("investigationType");
                }}
                sx={{
                  borderBottom:
                    activeTab === "investigationType"
                      ? "2px solid #194AF5"
                      : "2px solid transparent",
                  color:
                    activeTab === "investigationType" ? "#194AF5" : "#7D8DC4",
                  width: "max-content",
                  padding: "0.5rem 1rem",
                  fontWeight: "600",
                  cursor: "pointer",
                }}
              >
                Investigation Type
              </Box>
              <Box
                onClick={(e) => {
                  setActiveTab("complaint");
                }}
                sx={{
                  borderBottom:
                    activeTab === "complaint"
                      ? "2px solid #194AF5"
                      : "2px solid transparent",
                  color: activeTab === "complaint" ? "#194AF5" : "#7D8DC4",
                  width: "max-content",
                  padding: "0.5rem 1rem",
                  fontWeight: "600",
                  cursor: "pointer",
                }}
              >
                Complaint Master
              </Box>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
              {/* <CSVLink
                // data={csvSampleData}
                filename={"drugSample.csv"}
                className="btn btn-primary"
                target="_blank"
              >
                <Button
                  variant="contained"
                  fullWidth
                  sx={{
                    ...btnStyle,
                    // display: "flex",
                    // alignItems: "center",
                    // gap: "0.5rem",
                  }}
                >
                  {isUploading ? (
                    <CircularProgress sx={{ color: "white" }} size="1.5rem" />
                  ) : (
                    <>
                      <svg
                        width={16}
                        height={17}
                        style={{ marginRight: "0.5rem" }}
                        viewBox="0 0 16 17"
                        fill="none"
                      >
                        <g clipPath="url(#clip0_4226_14049)">
                          <path
                            d="M6.58614 12.5813C6.77187 12.7672 6.9924 12.9146 7.23514 13.0152C7.47787 13.1158 7.73805 13.1676 8.0008 13.1676C8.26355 13.1676 8.52373 13.1158 8.76646 13.0152C9.0092 12.9146 9.22973 12.7672 9.41547 12.5813L11.5561 10.4407C11.6709 10.3137 11.7325 10.1475 11.7281 9.97644C11.7237 9.80536 11.6537 9.64253 11.5325 9.52165C11.4114 9.40077 11.2484 9.3311 11.0773 9.32707C10.9062 9.32304 10.7402 9.38496 10.6135 9.5L8.6628 11.4513L8.66747 1.16667C8.66747 0.989856 8.59723 0.820286 8.47221 0.695262C8.34718 0.570238 8.17761 0.5 8.0008 0.5C7.82399 0.5 7.65442 0.570238 7.5294 0.695262C7.40437 0.820286 7.33413 0.989856 7.33413 1.16667L7.32814 11.4387L5.38814 9.5C5.26304 9.375 5.09341 9.3048 4.91657 9.30486C4.73972 9.30493 4.57014 9.37524 4.44514 9.50033C4.32013 9.62543 4.24994 9.79506 4.25 9.9719C4.25006 10.1487 4.32037 10.3183 4.44547 10.4433L6.58614 12.5813Z"
                            fill="#194AF5"
                          />
                          <path
                            d="M15.3333 11.167C15.1565 11.167 14.987 11.2372 14.8619 11.3623C14.7369 11.4873 14.6667 11.6568 14.6667 11.8337V14.5003C14.6667 14.6771 14.5964 14.8467 14.4714 14.9717C14.3464 15.0968 14.1768 15.167 14 15.167H2C1.82319 15.167 1.65362 15.0968 1.5286 14.9717C1.40357 14.8467 1.33333 14.6771 1.33333 14.5003V11.8337C1.33333 11.6568 1.2631 11.4873 1.13807 11.3623C1.01305 11.2372 0.843478 11.167 0.666667 11.167C0.489856 11.167 0.320286 11.2372 0.195262 11.3623C0.0702379 11.4873 0 11.6568 0 11.8337L0 14.5003C0 15.0308 0.210714 15.5395 0.585786 15.9145C0.960859 16.2896 1.46957 16.5003 2 16.5003H14C14.5304 16.5003 15.0391 16.2896 15.4142 15.9145C15.7893 15.5395 16 15.0308 16 14.5003V11.8337C16 11.6568 15.9298 11.4873 15.8047 11.3623C15.6797 11.2372 15.5101 11.167 15.3333 11.167Z"
                            fill="#194AF5"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_4226_14049">
                            <rect
                              width={16}
                              height={16}
                              fill="white"
                              transform="translate(0 0.5)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                      CSV template
                    </>
                  )}
                </Button>
              </CSVLink> */}
              {/* <Button
                sx={btnStyle}
                variant="contained"
                onClick={handleUploadButtonClick}
                fullWidth
              >
                {isUploading ? (
                  <CircularProgress sx={{ color: "white" }} size="1.5rem" />
                ) : (
                  <>Upload via CSV</>
                )}
                <input
                  type="file"
                  accept="text/csv"
                  id="input-file-upload"
                  multiple={false}
                  hidden
                  onChange={handleChange}
                />
              </Button> */}
              {activeTab === "test" && (
                <TestMasterSheetActions
                  searchText={searchText}
                  onImported={() => {
                    setPageNumber(0);
                    DrugListData();
                  }}
                />
              )}
              {activeTab !== "complaint" && (
                <Button
                  sx={{
                    ...btnStyle,
                    bgcolor: "#194AF5",
                    color: "white",
                    ":hover": {},
                  }}
                  variant="contained"
                  fullWidth
                  onClick={() => handleModal({})}
                >
                  {activeTab === "drug"
                    ? "Add Drug"
                    : activeTab === "test"
                    ? "Add Test"
                    : "Add Investigation Type"}
                </Button>
              )}
            </Box>
          </Grid>

          {activeTab === "complaint" ? (
            <ComplaintMaster searchText={searchText} />
          ) : (
            <Listtable
              tableheader={
                activeTab === "drug"
                  ? tableHeader
                  : activeTab === "test"
                  ? tableHeader2
                  : tableHeader3
              }
              tablebody={drugsData}
              rowsPerPage={rowsPerPage}
              page={pageNumber}
              handleChangePage={handleChangePage}
              handleChangeRowsPerPage={handleChangeRowsPerPage}
              totalCount={count}
              dataKeyName={
                activeTab === "drug"
                  ? keysName
                  : activeTab === "test"
                  ? keysName2
                  : keysName3
              }
              editHandle={handleModal}
              tag="drugs"
            />
          )}
        </Grid>
      </Grid>
      {openModal && activeTab !== "complaint" && (
        <ModalScreen
          open={openModal}
          onClose={handleModalClose}
          data={data}
          type={activeTab}
        />
      )}
    </>
  );
};

export default DrugList;
